import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, Pagination, Grid } from 'semantic-ui-react';
import { sortBy } from 'lodash';
import SimpleItemCard from './SimpleItemCard';

export default class PagedItemView extends Component {

    constructor() {
        super();

        this.state = {
            activePage: 1,
        };
    }

    componentDidMount() {
        this.setState({
            activePage: 1,
        });
    }

    onPageChange = (e, data) => {
        this.setState({
            activePage: data.activePage,
        });
    };

    render() {

        const {items, itemsPerRow} = this.props;
        const pageSize = this.props.pageSize || 10;
        const {activePage} = this.state;

        const sortedItems = sortBy(items, i => i.Name.English);

        const offset = (activePage - 1) * pageSize;
        const totalPages = Math.ceil(sortedItems.length / pageSize);
        const pagedItems = sortedItems.slice(offset, offset + pageSize);

        const paginationControl = totalPages > 1 ?
                                    <Pagination activePage={activePage} totalPages={totalPages} onPageChange={this.onPageChange} /> :
                                    null;

        return (
            <Grid columns={1}>
                <Grid.Row>
                    <Grid.Column>
                        <Card.Group stackable doubling itemsPerRow={itemsPerRow}>
                            {pagedItems.map( i=> <SimpleItemCard key={i.ItemKey} name={i.Name} itemKey={i.ItemKey} category={i.Category} image={i.Icon} rarity={i.Rarity} tags={i.Tags} />)}
                        </Card.Group>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row centered>
                    {paginationControl}
                </Grid.Row>
            </Grid>
        );
    }
}

PagedItemView.propTypes = {
    items: PropTypes.array,
    pageSize: PropTypes.number,
    itemsPerRow: PropTypes.number,
};


// WEBPACK FOOTER //
// ./src/common/items/PagedItemView.jsx